module.exports = __webpack_public_path__ + "static/img/jigou-guangzhou-bottom.bcf6d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-guangzhou-bottom.png
// module id = Dzjh
// module chunks = 2